import React, {Suspense, lazy, useRef, useState, useEffect} from "react";

import Modal from "../../components/Modal";
import TextInput from "../../components/TextInput"
import Spacer from "../../components/Spacer";

import { meterTypeComponentMapping } from "../Dashboard";
import BasicButton, {CancelButton, ConfirmButton} from "../../components/BasicButton";
import * as prosConnect from "../../prodect/ProsConnect";
import {USE_DEVELOPMENT_FEATURES} from "../../config";
import {awaitLoadProjectObjects} from "../../prodect/ProjectLoader";
import LoadingAnimation from "../../components/LoadingAnimation";

export default function MeterSettings(props) {
    const settingsRef = useRef(props.meterSettings)

    const Component = props.meterType in meterTypeComponentMapping
        ? lazy(() => meterTypeComponentMapping[props.meterType]().then(module => ({ default: module.MeterSettings })))
        : () => null

    let textEdited = !props.creation
    const defaultText = useRef(props.meterSettings.text)
    const [refresh, setRefresh] = useState(0)
    const [isLoadingProject, setIsLoadingProject] = useState(true)
    const [init, setInit] = useState(true)

    const handleSetInit = (val) => {
        if (textEdited) {
            setInit(false)
            return
        }
        if (init && ! textEdited) {
            settingsRef.current.text = defaultText.current + ' (' + val + ')'
            setInit(false)
        }
    }

    useEffect( () => {
        async function loadProjectFirstIncrement() {
            await awaitLoadProjectObjects(activeProject.getPid(), "MeterSettingsModal", true, true)
            setIsLoadingProject(false)
        }
        let activeProject = prosConnect.getActiveProject()
        if (!activeProject) {
            prosConnect.prosLogErr("Dasboard settings w/o active project")
            return
        }
        if (activeProject.hasItems) {
            setIsLoadingProject(false)
        } else {
            loadProjectFirstIncrement()
        }
    }, [])

    /**
     * @param {React.FormEvent} e 
     */
    function handleSubmit(e) {
        e.preventDefault()
        props.onSave(settingsRef.current)
    }

    function tryToUpdateText(val) {
        if (textEdited) {
            return
        }
        settingsRef.current.text = defaultText.current + ' (' + val + ')'
        setRefresh(refresh + 1)
    }

    function getDumpObjButton() {
        if (prosConnect.isSuperUserModeInUse() || USE_DEVELOPMENT_FEATURES) {
            return <>
                <Spacer size={"lg"}/>
                <p>{settingsRef.current.obj_id}</p>
                <BasicButton
                    btnClass={"2nd"}
                    label={"Dump obj"}
                    icon={"search"}
                    action={() => {
                        prosConnect.dumpProsObj(settingsRef.current)
                        prosConnect.dumpProsObj(props.meterData)
                    }}
                />
            </>
        }

        return ''
    }

    function renderContents() { return <>
        <form id="meterSettingsForm" onSubmit={handleSubmit}>
            <TextInput
                label={"Kuvaajan nimi"}
                value={settingsRef.current.text}
                isControlled={true}
                onChange={val => {
                    textEdited = true
                    settingsRef.current.text = val
                }}
            />
            <Spacer/>
            <Suspense fallback={<div>Ladataan...</div>}>
                <Component
                    setInit={handleSetInit}
                    dashboard={props.dashboard}
                    settingsRef={settingsRef}
                    tryToUpdateText={tryToUpdateText}
                    project_settings={props.project_settings}
                />
            </Suspense>
            {getDumpObjButton()}
        </form>
        <footer className={"popup-footer"}>
            <div className="btn-set">
                {settingsRef.current.obj_id && <ConfirmButton
                    btnClass={"2nd"}
                    label={"Poista kuvaaja..."}
                    action={()=> props.onDelete()}
                    confirmAction
                    btnType={"fatal"}
                />}
                <CancelButton
                    action={()=> props.onClose()}
                />
                <button
                    type="submit"
                    form={"meterSettingsForm"}
                    className={"btn btn-primary btn-confirm btn-icon btn-icon-left"}
                >
                    <span>Tallenna</span>
                </button>
            </div>
        </footer>
    </>
    }

    const header = settingsRef.current.obj_id
        ? 'Näyttöasetukset'
        : 'Luo kuvaaja'

    return (
        <Modal header={header} showCloseButton onClose={() => props.onClose()}>
            {isLoadingProject ? <LoadingAnimation size={"lg"} text={"Ladataan projektia..."} /> : renderContents()}
        </Modal>
    )
}